// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".link[data-v-6064ef66] {\n  cursor: pointer;\n}\nfooter[data-v-6064ef66] {\n  font-family: var(--footerElementsFontTypeface, inherit);\n  font-weight: var(--footerElementsFontWeight, inherit);\n  font-size: var(--footerElementsFontSize, unset);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
